import { AllInclusiveBoxIcon } from './AllInclusiveBoxIcon';

/**
 * author: Colton Wiscombe
 * id C8E30B1A-135A-4B8A-900C-D93FE1699720
 * name all-inclusive-box
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/all-inclusive-box.svg
 * tags
 */
export const InfinityBoxIcon = AllInclusiveBoxIcon;
export default InfinityBoxIcon